import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Anchor, Type } from "@ebscois/react-component-library";
import GenericTable from "../GenericTable";
import ViewInContextMenu from "../ViewInContextMenu";
import { StyledHeading, StyledTableWrapper, StyledContent } from "./_.styled";
import {
  affordances,
  logTableViewInContextClicked,
} from "../../util/analytics";

const { RIGHT_RAIL } = affordances;

const ContentRightRailTable = ({
  testId,
  tables = [],
  tablesContent,
  setIsDialogOpen,
  setTableData,
  slugTitle,
  slugPubType,
  isMobileDevice,
  isTabletDevice,
  handleOpenTable,
  isNonFreePreview,
}) => {
  const { pathname: currentSlugUrl } = useLocation();
  const tableToDisplay = tables?.length ? tables[0] : {};
  const {
    title = "",
    id = "",
    caption = "",
    standAlone = true,
  } = tableToDisplay;
  const dataForViewInContext = [
    {
      an: id,
      slug: `/${slugPubType}/${slugTitle}`,
      title,
    },
  ];
  const onViewInContextClick = () =>
    logTableViewInContextClicked({
      title: `${title} ${caption}`,
      tableId: id,
      affordance: RIGHT_RAIL,
    });

  return (
    <>
      {!!tables?.length && (
        <StyledTableWrapper data-testid={testId}>
          <StyledHeading>
            <Type element="h2" styledAs="h5">
              Tables
            </Type>
            <Anchor
              linkComponent={Link}
              href={`${currentSlugUrl}/tables`}
              data-testid={`${testId}-all-tables-link`}
              aria-label={`All tables (${tables.length})`}
            >
              All ({tables.length})
            </Anchor>
          </StyledHeading>
          <StyledContent>
            <GenericTable
              setIsDialogOpen={setIsDialogOpen}
              setTableData={setTableData}
              children={tablesContent[id]}
              tableText={title || "Table"}
              tableCaption={caption}
              isStandAlone={standAlone}
              isRightRails={true}
              affordance={RIGHT_RAIL}
              isNonFreePreview={isNonFreePreview}
              handleOpenTable={handleOpenTable}
            />
            {ViewInContextMenu({
              associatedTopics: dataForViewInContext,
              slugTitle,
              slugPubType,
              isRightRail: true,
              isMobileDevice,
              isTabletDevice,
              onClickHandler: onViewInContextClick,
            })}
          </StyledContent>
        </StyledTableWrapper>
      )}
    </>
  );
};

export default ContentRightRailTable;
